import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { PageSize } from 'src/app/enumeration/pageSize';
import { SurveyServices } from 'src/app/services/survey-services';
import { CheckAccessRoles } from 'src/app/utils/check-access-roles';
import { DateFormatPipe } from 'src/app/utils/date-format.pipe';

@Component({
  selector: 'app-dealer-survey-list',
  imports: [
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule
  ],
  templateUrl: './dealer-survey-list.html',
  styleUrl: './dealer-survey-list.css',
})
export class DealerSurveyList {

  route: ActivatedRoute = inject(ActivatedRoute);
  router: Router = inject(Router)
  apiService: SurveyServices = inject(SurveyServices);
  checkAccessRoles: CheckAccessRoles = inject(CheckAccessRoles);
  dateFormat: DateFormatPipe = inject(DateFormatPipe);

  surveyId: any;
  dealerSurveyList: any[] = [];
  pageSize = PageSize.SURVEY_LIST;
  page = 0;
  allTotal = 0;

  loading : boolean = false;

  ngOnInit() {
    this.surveyId = this.route.snapshot.paramMap.get('surveyId');

    this.getDealerSurveyList();
  }

  getDealerSurveyList() {
    this.loading = true;
    this.apiService.getDealerBySurvey(this.surveyId, this.page, this.pageSize).subscribe({
      next: (response) => {
        this.dealerSurveyList = response?.Object.dealerSurveyInfoRespLst || []
        this.allTotal = response?.Object.allTotal;
      },
      error: (e) => {
        this.loading = false;
        if (e) {
          alert(e)
        }
      },
      complete: () => {
        this.loading = false;
      },
    })
  }

  goToSurveyInfo(surveyId: any, dealerLoginName: any) {
    this.router.navigate(['/nav/surveyInfo', surveyId, dealerLoginName ], { skipLocationChange: true });
  }

  handlePageChange(event: number): void {
    if (!this.loading) {
      this.page = event - 1;
      this.getDealerSurveyList();
    }
  }
}
